import { Component, OnInit } from '@angular/core';
import { Auth } from '@aws-amplify/auth';
import { Router } from '@angular/router';

@Component({
  selector: 'app-okta-login',
  templateUrl: './okta-login.component.html',
  styleUrls: ['./okta-login.component.css'],
  standalone: false
})
export class OktaLoginComponent implements OnInit {
  constructor(private router: Router) {}

  ngOnInit(): void {
    try {
      Auth.currentAuthenticatedUser();
      this.router.navigate(['/redirect']);
    } catch {
      Auth.federatedSignIn({ customProvider: 'OKTA' });
    }
  }
}
